import AbstractController from '../../../../Js/Controller/AbstractController';
import Controller from '../../../../Js/Controller/Controller';
import PeriodImageSlider from '../Elements/PeriodImageSlider';
import Timeline from "../Elements/Timeline";

/**
 * History Controller
 *
 * @class
 */
class HistoryController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);
		this._registerElements(Timeline);
		this._registerElements(...PeriodImageSlider);
	}
}

export default (new HistoryController);
